import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("../pages/home/page"));
const CheckoutPage = lazy(() => import("../pages/checkout/page"));
const OrderCompletePage = lazy(() => import("../pages/order-complete/page"));
const MemberPage = lazy(() => import("../pages/member/page"));
const OrdersPage = lazy(() => import("../pages/orders/page"));
const SeasonalBookingPage = lazy(() => import("../pages/seasonal-booking/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "/order-complete",
    element: <OrderCompletePage />,
  },
  {
    path: "/member",
    element: <MemberPage />,
  },
  {
    path: "/orders",
    element: <OrdersPage />,
  },
  {
    path: "/seasonal-booking",
    element: <SeasonalBookingPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
